/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import {
  styBrideDivider,
  styBrideGroom,
  styBridePhoto,
  styBridePhotoFlip,
  styBrideProfile,
  styBrideWrapper,
  styBrideWrapperFlip,
} from "./styles";
import KhansaPhoto from "../../assets/khansa.jpg";
import IdanPhoto from "../../assets/idan.jpg";
import { styMargin, styPadding, stySectionTitle } from "../styles";
import { LocaleContext } from "../../context/LocaleContext";
import {
  txtBrideFather,
  txtBrideGroomTitle,
  txtBrideInfo,
  txtBrideMother,
  txtBrideName,
  txtGroomFather,
  txtGroomInfo,
  txtGroomMother,
  txtGroomName,
} from "./locales";

const BrideGroom = () => {
  const { lang } = useContext(LocaleContext);

  return (
    <section css={styBrideGroom}>
      <div css={stySectionTitle}>
        <h1>{txtBrideGroomTitle[lang]}</h1>
      </div>
      <div css={styPadding("24px 0")}>
        <div css={[styBrideWrapperFlip, styPadding("16px 0")]}>
          <div css={styBrideProfile}>
            <h4>{txtBrideName[lang]}</h4>
            <p css={[styMargin("12px 0 4px")]} className="child">
              {txtBrideInfo[lang]}
            </p>
            <p css={[styMargin("0")]}>
              {txtBrideFather[lang]}
              <br />
              {txtBrideMother[lang]}
            </p>
          </div>
          <div css={styBridePhotoFlip}>
            <div>
              <img src={KhansaPhoto} alt="khansa" />
            </div>
          </div>
        </div>
        <div css={styBrideDivider}>&</div>
        <div css={[styBrideWrapper, styPadding("16px 0")]}>
          <div css={styBrideProfile}>
            <h4>{txtGroomName[lang]}</h4>
            <p css={[styMargin("12px 0 4px")]} className="child">
              {txtGroomInfo[lang]}
            </p>
            <p css={[styMargin("0")]}>
              {txtGroomFather[lang]}
              <br />
              {txtGroomMother[lang]}
            </p>
          </div>
          <div css={styBridePhoto}>
            <div css="reverse">
              <img src={IdanPhoto} alt="idan" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrideGroom;
